// @ts-nocheck
import { Suspense, useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getLabels } from '@utils/utils';
import useWindowSize from '@hooks/useWindowSize';
import ScrollToTop from '@hooks/ScrollToTop';
import * as actions from '@redux-actions/';
import { RootState } from './store/store';

import Dashboard from '@pages/Dashboard';
import EyeExams from '@pages/MyAppointments/EyeExams';
import InStoreServices from '@pages/MyAppointments/InStoreServices';
import OnlineOrders from '@pages/MyPurchases/OnlineOrders';
//import InStorePurchases from '@pages/MyPurchases/InStorePurchases';
import PersonalDetails from '@pages/MyProfile/PersonalDetails';
import Settings from '@pages/MyProfile/Settings';
import MyStores from '@pages/MyProfile/MyStores';
import PaymentMethods from '@pages/MyPurchases/PaymentMethods';
import Addresses from '@pages/MyPurchases/Addresses';
import Inbox from '@pages/MyProfile/Inbox';

import MyPrescriptions from '@pages/MyAppointments/MyPrescriptions';
import PrescriptionContactWizard from '@pages/MyAppointments/PrescriptionContactWizard';
import AddPrescriptionDefault from '@pages/MyAppointments/AddPrescriptionDefault';
import FullPrescriptionForm from '@pages/MyAppointments/FullPrescriptionForm';

import Redirect from '@components/Redirect';
import OrderDetail from '@pages/MyPurchases/OrderDetail';
import OrderDetailRetail from '@pages/MyPurchases/OrderDetailRetail';
import axios from 'axios';

declare global {
    interface Window {
        globalMethods: any;
        tealium_data2track: any[];
    }

    interface DiscountedPricesManager {
        findLastUnitPrice: (partNumber: string) => string[5];
        findFirstUnitPrice: (partNumber: string) => string[5];
    }

    const discountedPricesManager: DiscountedPricesManager;
}

export default ({ data }) => {
    const dispatch = useDispatch();

    const [isKeyboardUser, setIsKeyboardUser] = useState(false);

    const config = useSelector((state: RootState) => state.common.config);

    /* Set Axios default headers to not cache */
    axios.defaults.headers = {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
    };

    /*
        globalMethods -  object that contains all the function called from the functions defined in
        'callFromComponentToMyAccount' object in config object.
    */
    const globalMethods = {};

    window.globalMethods = globalMethods;

    // for accessibility
    const setKeyboardUser = e => {
        if (e.code === 'Tab') {
            setIsKeyboardUser(true);
        }
    };

    const unsetKeyboardUser = () => {
        setIsKeyboardUser(false);
    };

    const changeHeightPage = () => {
        let selectorElement = document.querySelector(config.selector);
        if (selectorElement) {
            selectorElement.style.minHeight = 'unset';
        }
    };

    /* At first render, save the config, get labels */
    useEffect(() => {
        dispatch(actions.saveConfig(data));
        getLabels(data.langUrl);

        //attach events for 'Tab' navigation
        window.addEventListener('keydown', setKeyboardUser);
        window.addEventListener('mousedown', unsetKeyboardUser);
    }, []);

    useEffect(() => {
        if (!!config) {
            changeHeightPage()
        }
    }, [config]);

    const size = useWindowSize();

    //every time the size of the window changes, control if it is a mobile or desktop view
    useEffect(() => {
        // const isMobileValue = isMobile.any() || size.width < 1200;
        const isMobileValue = size.width < 1200;
        dispatch(actions.setIsMobile(isMobileValue));
    }, [size]);

    return (
        <div
            id="lc-my-account"
            className={`lc-my-account ${isKeyboardUser === true ? 'isKeyboardUser' : ''}`}
        >
            {!!config && (
                <Suspense fallback={<></>}>
                    <Router>
                        <ScrollToTop>
                            <Routes>
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_UserSummary',
                                        });
                                    }}
                                    path={config.pagesUrl.dashboard}
                                    element={<Dashboard />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Static',
                                        });
                                    }}
                                    path={config.pagesUrl.myAppointments.eyeExams}
                                    element={<EyeExams />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Static',
                                        });
                                    }}
                                    path={config.pagesUrl.myAppointments.myPrescriptions}
                                    element={<MyPrescriptions />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Static',
                                        });
                                    }}
                                    path={config.pagesUrl.myAppointments.addPrescriptionForm}
                                    element={<FullPrescriptionForm isEditingPrescription={false} />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Static',
                                        });
                                    }}
                                    path={config.pagesUrl.myAppointments.editPrescriptionForm}
                                    element={<FullPrescriptionForm isEditingPrescription={true} />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Static',
                                        });
                                    }}
                                    path={config.pagesUrl.myAppointments.addPrescriptionContact}
                                    element={
                                        <PrescriptionContactWizard isEditingPrescription={false} />
                                    }
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Static',
                                        });
                                    }}
                                    path={config.pagesUrl.myAppointments.editPrescriptionContact}
                                    element={
                                        <PrescriptionContactWizard isEditingPrescription={true} />
                                    }
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Static',
                                        });
                                    }}
                                    path={config.pagesUrl.myAppointments.addPrescriptionDefault}
                                    element={<AddPrescriptionDefault />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Static',
                                        });
                                    }}
                                    path={config.pagesUrl.myAppointments.inStoreServices}
                                    element={<InStoreServices />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_History',
                                        });
                                    }}
                                    path={config.pagesUrl.myPurchases.onlineOrders}
                                    element={<OnlineOrders />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_History',
                                        });
                                    }}
                                    path={config.pagesUrl.myPurchases.orderDetail}
                                    element={<OrderDetail />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_History',
                                        });
                                    }}
                                    path={config.pagesUrl.myPurchases.orderDetailRetail}
                                    element={<OrderDetailRetail />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Profile',
                                        });
                                    }}
                                    path={config.pagesUrl.myProfile.personalDetails}
                                    element={<PersonalDetails />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Profile',
                                        });
                                    }}
                                    path={config.pagesUrl.myProfile.settings}
                                    element={<Settings />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Inbox',
                                        });
                                    }}
                                    path={config.pagesUrl.myProfile.inbox}
                                    element={<Inbox />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Profile',
                                        });
                                    }}
                                    path={config.pagesUrl.myProfile.myStores}
                                    element={<MyStores />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Profile',
                                        });
                                    }}
                                    path={config.pagesUrl.myPurchases.paymentMethods}
                                    element={<PaymentMethods />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Profile',
                                        });
                                    }}
                                    path={config.pagesUrl.myPurchases.addresses}
                                    element={<Addresses />}
                                />
                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_Profile',
                                        });
                                    }}
                                    path={config.pagesUrl.myProfile.mySavedItems}
                                />

                                <Route
                                    onClick={() => {
                                        tealium_data2track.push({
                                            id: 'Click',
                                            data_element_id: 'AccountSummary_UserSummary',
                                        });
                                    }}
                                    path="/"
                                    element={<Redirect to={config.pagesUrl.dashboard} />}
                                />
                            </Routes>
                        </ScrollToTop>
                    </Router>
                </Suspense>
            )}
        </div>
    );
};
